import {useDispatch} from "react-redux";

import {type AppDispatch} from "./store";

// Typed dispatch so thunks type-check (redux 5 / RTK 2 reject AsyncThunkAction on the
// plain useDispatch() Dispatch<UnknownAction>).
export const useAppDispatch = () => useDispatch<AppDispatch>();
